<template>
  <div class="push_wrapper">
    <h2>新建推送</h2>
    <Form
			class="FormWrapper"
			:ref="pushData"
			:model="pushData"
			:rules="ruleValidate"
			:label-width="200"
			>
      <Row>
				<Col span="14">
					<FormItem prop="id" label="推送ID">
						<Input v-model="pushData.id" placeholder="选择文件"></Input>
					</FormItem>
				</Col>
      </Row>
      <Row>
				<Col span="14">
					<FormItem prop="title" label="推送标题">
						<Input v-model="pushData.title" placeholder="请输入不超过32个字的推送标题"></Input>
					</FormItem>
				</Col>
      </Row>
      <Row>
				<Col span="14">
					<FormItem prop="content" label="推送内容">
						<Input type="textarea" :rows="4" v-model="pushData.content" placeholder="请输入不超过2048个字的推送内容"></Input>
					</FormItem>
				</Col>
      </Row>
      <Row>
				<Col span="14">
					<FormItem prop="mUrl" label="推送URL">
						<Input v-model="pushData.mUrl" placeholder="请输入推送URL"></Input>
					</FormItem>
				</Col>
      </Row>
      <Row>
				<Col span="14">
					<FormItem prop="target" label="路由（target）">
						<Input v-model="pushData.target" placeholder="请输入客户端统一的跳转路由"></Input>
					</FormItem>
				</Col>
      </Row>
      <Row>
				<Col span="14">
					<FormItem prop="parameter" label="路由参数（parameter）">
						<Input v-model="pushData.parameter" placeholder="请输入客户端统一的路由参数"></Input>
					</FormItem>
				</Col>
      </Row>
      <Button class="btn" type="primary" >提交</Button>
    </Form>
  </div>
</template>

<script>
export default {
  data(){
    return {
      pushData:{},
      ruleValidate:{
        id:[],
        title:[
          { required: true, message: '请输入不超过32个字的推送标题', max:32, trigger: 'blur',type:'string'}
        ],
        content:[
          { required: true, message: '请输入不超过2048个字的推送标题', max:2048, trigger: 'blur',type:'string'}
        ],
      }
    }
  },

}
</script>

<style scoped>
  .push_wrapper{
    position: relative;
    padding-top: 0;margin-left:26px;margin-top:30px;
  }
  .FormWrapper{
    margin-top: 30px;
  }
  .btn{
    position: absolute;
    left: 30%;
  }
</style>